<template>
  <div class="text-center tablet:text-right">
    <p class="">
      built with <em class="fas fa-heart text-red-light"></em> in Genval, Belgium
    </p>
  </div>
</template>

<script>
export default {
    name: 'Footer'
};
</script>

<style lang="scss" scoped>
</style>
